import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from '../../shared/common/common.service';
import { AuthService } from '../auth.service';

@Injectable()
export class PortalGuard {

  constructor(private authService: AuthService, 
    private commonService: CommonService, 
    private toastrService: ToastrService,
    private router: Router) { }

  canActivate() {
    if (this.authService.canAccessPortal()) {
      return true;
    }
    
    this.commonService.showLoader(false);
    this.toastrService.error("You are not authorized to access the Portal module.\n\nPlease contact IT for additional information.", "Unauthorized");
    this.router.navigate(['unauthorized']);
    return false;    
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/guards/portal-guard.service.ts